import { observer } from "mobx-react-lite";

import { KioskAccessListProps, useKioskAccessListState } from "./list.state";
import { KioskAccessListView } from "./list.view";

export const KioskAccessList = observer((props: KioskAccessListProps) => {
  const state = useKioskAccessListState(props);
  return <KioskAccessListView state={state} />;
});
